module.exports = __webpack_public_path__ + "img/Giving-Gamers-Colour.51c7fba5.png";